// extracted by mini-css-extract-plugin
module.exports = {"popconfirm":"Popconfirm_popconfirm__bMTYl","buttons":"Popconfirm_buttons__HNuCc","content":"Popconfirm_content__TwxI_","title":"Popconfirm_title__QcIoq"};